import styled from "styled-components";
import {InputNumber, Row, Select} from "antd";

export const FilterContainer = styled(Row)``;

export const RangePickerContainer = styled.div`
    margin-left: 8px;
`;

export const SelectField = styled(Select)`
    width: 100%;
`;

export const Title = styled.h2`
    width: 100%;
`;

export const NumberInput = styled(InputNumber)`
    .ant-input-number-handler-wrap {
        visibility: hidden;
    }
    .ant-input-number-input-wrap {
        & > input {
            padding: unset !important;
            text-align: center;
            font-size: 16px;
            &:hover,
            &:focus {
                outline: none;
            }
        }
    }

    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px !important;
    height: 25px !important;
    margin: 0 !important;
    background-color: #edf1fc;
    border-color: #edf1fc;

    &:active,
    &:hover,
    &:focus {
        background-color: white;
        border-color: #d9d9d9;
        box-shadow: none !important;
    }
`;
